import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [sessionExpired] = useState(() => {
    const expired = sessionStorage.getItem('ventas_session_expired');
    if (expired) sessionStorage.removeItem('ventas_session_expired');
    return !!expired;
  });
  const [lockdown, setLockdown] = useState(() => {
    const flagged = sessionStorage.getItem('ventas_lockdown');
    if (flagged) sessionStorage.removeItem('ventas_lockdown');
    return !!flagged;
  });
  useEffect(() => { axios.get('/api/status').then(r => setLockdown(l => l || !!r.data.lockdown)).catch(() => {}); }, []);
  const { login } = useAuth();
  const navigate = useNavigate();
  // The page a signed-out link was going to (PrivateRoute) — only a path inside the app.
  const from = useLocation().state?.from;
  const backTo = typeof from === 'string' && from.startsWith('/') && !from.startsWith('//') ? from : '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!username || !password) {
      setErrorMessage('Por favor ingresa usuario y contraseña.');
      return;
    }

    try {
      await login(username, password);
      navigate(backTo);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Credenciales inválidas.');
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--mm-bg)' }}>
      <div className="card shadow-lg p-4" style={{ maxWidth: '420px', width: '100%', borderRadius: '16px' }}>
        <div className="text-center mb-4">
          <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '2rem', color: 'var(--mm-cyan)', fontWeight: 700, letterSpacing: '-0.01em' }}>
            VENTAS
          </div>
          <h4 className="mt-2 mb-0" style={{ color: 'var(--mm-muted)', fontSize: '1.05rem', fontWeight: 500 }}>Iniciar sesión</h4>
        </div>

        {lockdown && (
          <div className="alert alert-danger text-center">
            <strong>El sistema está en bloqueo de emergencia.</strong>
            <div className="small">Solo los propietarios pueden entrar por ahora.</div>
          </div>
        )}
        {sessionExpired && !errorMessage && !lockdown && (
          <div className="alert alert-warning text-center">Tu sesión expiró. Inicia sesión de nuevo.</div>
        )}
        {errorMessage && (
          <div className="alert alert-danger text-center">{errorMessage}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="username" className="form-label text-muted">Usuario</label>
            <input
              type="text"
              className="form-control"
              id="username"
              placeholder="Ingresa tu usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label htmlFor="password" className="form-label text-muted">Contraseña</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="btn w-100"
            style={{
              background: 'linear-gradient(to right, var(--mm-cyan), #0E8C86)',
              color: '#06222B',
              fontWeight: 'bold',
              borderRadius: '10px',
            }}
          >
            Ingresar
          </button>
        </form>

        <div className="text-center mt-3">
          <Link to="/recuperar" className="small text-muted">¿No puedes entrar? Usar un código de recuperación</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
